import { AUTH_API_URL, API_URL } from '../services/apiService';

const UPLOAD_ENDPOINTS = {
  game: 'Upload/gamePic',
  tournament: 'upload/tournamentPic',
  rank: 'Upload/rankPic',
  achievement: 'Upload/achievementPic',
  slider: 'upload/sliderPic',
  news: 'upload/newsPic',
  match: 'upload/matchpic',
  general: 'upload/general',
};

export const uploadImage = async (file, uploadType) => {
  const formData = new FormData();
  formData.append('file', file);

  const endpoint = UPLOAD_ENDPOINTS[uploadType] || UPLOAD_ENDPOINTS.general;
  const uploadUrl = `${API_URL}/${endpoint}`;
  const token = localStorage.getItem('admin_token');

  try {
    const response = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Server responded with ${response.status}`);
    }

    const data = await response.json();

    if (data.path) {
      return data.path;
    }
    if (typeof data === 'string') {
      return data;
    }
    if (data.data && data.data.path) {
      return data.data.path;
    }

    throw new Error('Invalid response format from server');
  } catch (error) {
    console.error('Image upload error:', error);
    throw new Error(error.message || 'Failed to upload image');
  }
};

export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return '';

  if (imagePath.startsWith('http')) {
    return imagePath;
  }

  let normalizedPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  if (normalizedPath.toLowerCase().startsWith('api/')) {
    normalizedPath = normalizedPath.slice(4);
  }

  return `${AUTH_API_URL}/${normalizedPath}`;
};

export const validateImageFile = (file) => {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  const maxSize = 5 * 1024 * 1024;

  if (!allowedTypes.includes(file.type)) {
    throw new Error('فرمت فایل پشتیبانی نمی‌شود. لطفاً فایل تصویری معتبر انتخاب کنید.');
  }

  if (file.size > maxSize) {
    throw new Error('حجم فایل نباید بیشتر از 5 مگابایت باشد.');
  }

  return true;
};
